import { render, staticRenderFns } from "./TransportationPermissionMapper.vue?vue&type=template&id=543f8fac"
import script from "./TransportationPermissionMapper.vue?vue&type=script&lang=ts"
export * from "./TransportationPermissionMapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports